/* eslint-disable */
<template>
  <section class="profile-page">
    <vue-basic-alert :duration="300" :closeIn="2000" ref="alert" />

    <div class="page-body">

      <!-- ── Page Header ── -->
      <div class="page-header">
        <div class="header-left">
          <div class="header-bar"></div>
          <div>
            <p class="breadcrumb-label">Account | ගිණුම</p>
            <h1 class="page-title">Edit Profile</h1>
            <p class="page-subtitle">ඔබගේ පැතිකඩ සංස්කරණය කරන්න</p>
          </div>
        </div>
        <div class="user-chip" v-if="user">
          <div class="user-avatar">{{ user.cus_name ? user.cus_name.charAt(0).toUpperCase() : 'U' }}</div>
          <div class="user-info">
            <span class="user-name">{{ user.cus_name }}</span>
            <span class="user-nic">NIC: {{ user.cus_nic }}</span>
          </div>
        </div>
      </div>

      <!-- ── Personal Information Card ── -->
      <div class="form-card">
        <div class="card-header">
          <div class="step-badge">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
            </svg>
          </div>
          <div>
            <h2 class="card-title">Personal Information</h2>
            <p class="card-desc">පෞද්ගලික තොරතුරු | Update your name, address and contact details</p>
          </div>
        </div>

        <form id="editProfile" novalidate autocomplete="off">
          <div class="field-grid two-col">

            <div class="field-group">
              <label class="field-label" for="uName">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                </svg>
                Full Name
              </label>
              <input type="text" id="uName" class="field-input" :class="{ filled: proObj.name }"
                v-model="proObj.name" placeholder="Enter your full name" />
              <p class="error-mess" v-if="errorObj.nameErr.length > 0">{{ errorObj.nameErr[0] }}</p>
            </div>

            <div class="field-group">
              <label class="field-label" for="uPhone">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"/>
                </svg>
                Phone Number
              </label>
              <input type="text" id="uPhone" class="field-input" :class="{ filled: proObj.phone }"
                v-model="proObj.phone" placeholder="Enter phone number" />
              <p class="error-mess" v-if="errorObj.phoneErr.length > 0">{{ errorObj.phoneErr[0] }}</p>
            </div>

            <div class="field-group">
              <label class="field-label" for="uAddress">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 12l2-2m0 0l7-7 7 7M5 10v10a1 1 0 001 1h3m10-11l2 2m-2-2v10a1 1 0 01-1 1h-3m-6 0a1 1 0 001-1v-4a1 1 0 011-1h2a1 1 0 011 1v4a1 1 0 001 1m-6 0h6"/>
                </svg>
                Address
              </label>
              <input type="text" id="uAddress" class="field-input" :class="{ filled: proObj.address }"
                v-model="proObj.address" placeholder="Enter your address" />
              <p class="error-mess" v-if="errorObj.addErr.length > 0">{{ errorObj.addErr[0] }}</p>
            </div>

            <div class="field-group">
              <label class="field-label" for="uEmail">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"/>
                </svg>
                Email Address
              </label>
              <input type="email" id="uEmail" class="field-input" :class="{ filled: proObj.email }"
                v-model="proObj.email" placeholder="Enter email address" />
              <p class="error-mess" v-if="errorObj.emailErr.length > 0">{{ errorObj.emailErr[0] }}</p>
            </div>

          </div>

          <div class="card-footer">
            <button type="button" class="submit-btn" @click="handleSubmit">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"/>
              </svg>
              Update Profile
            </button>
          </div>
        </form>
      </div>

      <!-- ── Registered Local Councils Card ── -->
      <div class="form-card">
        <div class="card-header">
          <div class="step-badge">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
            </svg>
          </div>
          <div>
            <h2 class="card-title">Registered Local Councils</h2>
            <p class="card-desc">ලියාපදිංචි ප්‍රාදේශීය සභා | Councils linked to your account</p>
          </div>
        </div>

        <!-- Table -->
        <div class="table-wrap" v-if="prasabha.length">
          <table class="data-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Sabha Name</th>
                <th>Contact</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(sabha, index) in prasabha" :key="sabha.sb_code">
                <td class="idx-cell">{{ index + 1 }}</td>
                <td class="sabha-cell">
                  <div class="sabha-name">{{ sabha.sb_name_en }}</div>
                </td>
                <td class="contact-cell">{{ sabha.sb_contact }}</td>
                <td>
                  <button class="remove-btn" @click="removeSabha(sabha.sb_code)">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"/>
                    </svg>
                    Remove
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Empty -->
        <div v-else class="empty-state">
          <div class="empty-icon">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5"/>
            </svg>
          </div>
          <p>No local councils registered yet.</p>
        </div>
      </div>

      <!-- ── Add New Sabha Card ── -->
      <div class="form-card">
        <div class="card-header">
          <div class="step-badge add-badge">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
            </svg>
          </div>
          <div>
            <h2 class="card-title">Add a New Local Council</h2>
            <p class="card-desc">ඔබගේ පැතිකඩට නව ප්‍රාදේශීය සභාවක් එකතු කරන්න</p>
          </div>
        </div>

        <div class="field-grid three-col">

          <div class="field-group">
            <label class="field-label" for="district">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"/>
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
              District <span class="req">*</span>
            </label>
            <div class="input-wrap">
              <select @change="changedist" v-model="proObj.dis" id="district"
                class="field-input select-input" :class="{ filled: proObj.dis }">
                <option value="" disabled>Choose District</option>
                <option v-for="ds in Districts" :key="ds.dist_code" :value="ds.dist_code">{{ ds.dist_name }}</option>
              </select>
              <div class="select-chevron">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </div>
            </div>
            <p class="error-mess" v-if="errorObj.disErr.length > 0">{{ errorObj.disErr[0] }}</p>
          </div>

          <div class="field-group">
            <label class="field-label" for="pradeshiya">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
              </svg>
              Pradeshiya Sabha <span class="req">*</span>
            </label>
            <div class="input-wrap">
              <select v-model="proObj.pra_sabha" id="pradeshiya"
                class="field-input select-input" :class="{ filled: proObj.pra_sabha }">
                <option value="" disabled>Choose Sabha</option>
                <option v-for="ps in p_sabha" :key="ps.sb_code" :value="ps.sb_code">
                  {{ ps.sb_name_en }} | {{ ps.sb_name_sin }}
                </option>
              </select>
              <div class="select-chevron">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </div>
            </div>
            <p class="error-mess" v-if="errorObj.praErr.length > 0">{{ errorObj.praErr[0] }}</p>
          </div>

          <div class="field-group add-btn-group">
            <label class="field-label invisible">Action</label>
            <button type="button" class="add-sabha-btn" @click="handlesabha">
              <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
              </svg>
              Add Sabha
            </button>
          </div>

        </div>
      </div>

    </div>
  </section>
</template>


<script>
import axios from 'axios';
import VueBasicAlert from 'vue-basic-alert';
import { mapState, mapMutations } from "vuex";

export default {
  name: "Profile",
  components: { VueBasicAlert },
  data() {
    return {
      proObj: { pro: "", dis: "", pra_sabha: "", name: "", phone: "", address: "", email: "" },
      errorObj: { disErr: [], proErr: [], praErr: [], nameErr: [], phoneErr: [], addErr: [], emailErr: [] },
      matchProfile: undefined, matchUser: undefined, theProfile: [],
      cus_nic: '', Nic: '',
      p_sabha: [], Districts: [], province: [], prasabha: [],
      Uprovince: '',
    };
  },
  computed: { ...mapState(["user"]) },
  created() {
    this.showAUser();
    this.getSessionData();
    this.AllDistricts();
    this.Allprovince();
    this.AllprSabha();
    this.AllregisterprSabha();
  },
  methods: {
    ...mapMutations(["setUser"]),

    async MatchUser(nic) {
      let data = await axios.get('/customersdata/' + nic);
      this.matchUser = data.data;
    },

    async getSessionData() {
      const data = JSON.parse(sessionStorage.getItem('Userdata'));
      if (data) { this.Nic = data.Unic; this.Uprovince = data.Upro; }
      await this.MatchUser(this.Nic);
      this.setUser(this.matchUser);
    },

    async showAUser() {
      this.theProfile = (await axios.get('/customersdata/' + this.user.cus_nic)).data;
      this.proObj.name    = this.theProfile.cus_name;
      this.proObj.phone   = this.theProfile.cus_contact;
      this.proObj.address = this.theProfile.cus_address;
      this.proObj.email   = this.theProfile.cus_email;
    },

    async Allprovince()   { this.province  = (await axios.get('/provinces/')).data; },
    async AllDistricts()  {
      let r = await axios.get('/districts/' + this.Uprovince);
      this.Districts = r.data;
    },
    async AllprSabha()    { this.p_sabha   = (await axios.get('/Prasabha/')).data; },

    async changeprovince() {
      let r = await axios.get('/districts/' + this.Uprovince);
      this.Districts = r.data;
    },
    async changedist() {
      let r = await axios.get('/Prasabha/' + this.proObj.dis);
      this.p_sabha = r.data;
    },

    async AllregisterprSabha() {
      try {
        const res = await axios.get('/customersabha/' + this.Nic);
        const all = res.data;
        if (all && all.length > 0) {
          this.prasabha = [];
          for (const s of all) {
            if (s.sabha) {
              const r = await axios.get('/PraSabhadata/' + s.sabha);
              this.prasabha.push(...r.data);
            }
          }
        }
      } catch (e) { console.error(e); }
    },

    async removeSabha(sb_code) {
      try {
        await axios.delete(`/deletecussabha/${sb_code}`);
        this.prasabha = this.prasabha.filter(s => s.sb_code !== sb_code);
        this.$refs.alert.showAlert('success', 'Sabha removed successfully!');
      } catch (e) {
        this.$refs.alert.showAlert('error', 'Failed to remove sabha. Please try again.');
      }
    },

    async updateProfileMatch(id) {
      let data = await axios.get('/customersdata/' + id);
      this.matchProfile = data.data;
    },

    resetCheckErr() {
      this.errorObj.nameErr = []; this.errorObj.phoneErr = [];
      this.errorObj.addErr  = []; this.errorObj.emailErr = [];
    },

    checkEmptyErr() {
      for (var t in this.errorObj) { if (this.errorObj[t].length !== 0) return false; }
      return true;
    },

    async handleSubmit() {
      if (!this.user) {
        this.$refs.alert.showAlert('error', 'Please Login to Continue!');
        this.$router.push("/login"); return;
      }
      await this.updateProfileMatch(this.user.cus_nic);
      if (!this.matchProfile) { this.$refs.alert.showAlert('error', 'Something went wrong'); return; }
      await axios.put("/customersupdate/" + this.user.cus_nic, {
        cus_name: this.proObj.name, cus_contact: this.proObj.phone,
        cus_address: this.proObj.address, cus_email: this.proObj.email,
      });
      this.$refs.alert.showAlert('success', 'Profile Updated Successfully!');
    },

    async handlesabha() {
      if (!this.user) {
        this.$refs.alert.showAlert('error', 'Please Login to Continue!');
        this.$router.push("/login"); return;
      }
      if (!this.proObj.dis || !this.proObj.pra_sabha || !this.Nic) {
        this.$refs.alert.showAlert('error', 'Please fill out all required fields.');
        return;
      }
      try {
        await axios.post("/addcustomersabha/", {
          province: this.proObj.pro, district: this.proObj.dis,
          sabha: this.proObj.pra_sabha, cus_nic: this.Nic,
        });
        this.$refs.alert.showAlert('success', 'Sabha Added Successfully!');
        this.proObj.pro = ""; this.proObj.dis = ""; this.proObj.pra_sabha = "";
        this.AllregisterprSabha();
      } catch (e) {
        this.$refs.alert.showAlert('error', 'Failed to add. Please try again.');
      }
    },
  },
};
</script>


<style scoped>
@import url('https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,300;9..40,400;9..40,500;9..40,600;9..40,700&family=DM+Serif+Display&display=swap');

* { box-sizing: border-box; }

/* ── Page ── */
.profile-page {
  min-height: 100vh;
  background: #f2f0ec;
  font-family: 'DM Sans', sans-serif;
  padding: 2rem 1.5rem 4rem;
}
.page-body { max-width: 1100px; margin: 0 auto; }

/* ── Page Header ── */
.page-header {
  display: flex; align-items: flex-start; justify-content: space-between;
  margin-bottom: 2.4rem; gap: 1.5rem; flex-wrap: wrap;
}
.header-left { display: flex; align-items: flex-start; gap: 1.4rem; }
.header-bar {
  width: 5px; min-height: 72px; border-radius: 99px;
  background: linear-gradient(180deg, #7c2d12, #c2440a);
  flex-shrink: 0; margin-top: 4px;
}
.breadcrumb-label { font-size: 1.2rem; font-weight: 500; letter-spacing: 0.12em; text-transform: uppercase; color: #9a6652; margin: 0 0 0.3rem; }
.page-title { font-family: 'DM Serif Display', serif; font-size: 2.6rem; color: #1c0f0a; margin: 0 0 0.3rem; }
.page-subtitle { font-size: 1.3rem; color: #9a8070; margin: 0; }

/* User Chip */
.user-chip {
  display: flex; align-items: center; gap: 0.9rem;
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 0.9rem; padding: 0.7rem 1.2rem;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
}
.user-avatar {
  width: 3.4rem; height: 3.4rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; font-family: 'DM Serif Display', serif;
  font-size: 1.5rem; font-weight: 700;
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.user-info { display: flex; flex-direction: column; gap: 0.1rem; }
.user-name { font-size: 1.35rem; font-weight: 600; color: #1c0f0a; }
.user-nic  { font-size: 1.1rem; color: #9a8070; }

/* ── Form Cards ── */
.form-card {
  background: #fff; border: 1px solid #e5ddd5;
  border-radius: 1.2rem; padding: 2.2rem;
  box-shadow: 0 1px 4px rgba(100,50,30,0.06);
  margin-bottom: 2rem;
}

.card-header {
  display: flex; align-items: center; gap: 1.4rem;
  margin-bottom: 2rem; padding-bottom: 1.5rem; border-bottom: 1px solid #f0e6de;
}
.step-badge {
  width: 4rem; height: 4rem; border-radius: 50%;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.step-badge svg { width: 1.9rem; height: 1.9rem; stroke: #fff; }
.add-badge { background: linear-gradient(135deg, #166534, #16a34a); }
.card-title { font-family: 'DM Serif Display', serif; font-size: 1.8rem; color: #1c0f0a; margin: 0 0 0.2rem; }
.card-desc  { font-size: 1.3rem; color: #9a8070; margin: 0; }

/* ── Field Grids ── */
.field-grid { display: grid; gap: 1.2rem; }
.two-col   { grid-template-columns: 1fr 1fr; }
.three-col { grid-template-columns: 1fr 1fr auto; align-items: end; }

.field-group { display: flex; flex-direction: column; gap: 0.4rem; }
.field-label {
  display: flex; align-items: center; gap: 0.5rem;
  font-size: 1.2rem; font-weight: 600; color: #4a3028;
}
.field-label svg { width: 1.4rem; height: 1.4rem; stroke: #c2440a; flex-shrink: 0; }
.req { color: #c2440a; }
.invisible { visibility: hidden; }

.input-wrap { position: relative; }

.field-input {
  width: 100%;
  padding: 0.7rem 1.1rem;
  font-size: 1.3rem; font-family: 'DM Sans', sans-serif;
  color: #1c0f0a; background: #faf8f6;
  border: 2px solid #e5ddd5; border-radius: 0.7rem;
  transition: all 0.2s;
}
.field-input:focus {
  outline: none; border-color: #c2440a;
  background: #fff; box-shadow: 0 0 0 3px rgba(194,68,10,0.09);
}
.field-input.filled { background: #fff; border-color: #c2440a; }
.field-input::placeholder { color: #b0a09a; }

/* Select */
.select-input { appearance: none; -webkit-appearance: none; cursor: pointer; padding-right: 2.8rem; }
.select-chevron {
  position: absolute; right: 0.9rem; top: 50%; transform: translateY(-50%);
  width: 1.4rem; height: 1.4rem; color: #9a8070; pointer-events: none;
}
.select-chevron svg { width: 100%; height: 100%; }

.error-mess { font-size: 1.15rem; color: #b91c1c; margin: 0; }
.error-mess::before { content: '⚠ '; }

/* ── Card Footer ── */
.card-footer {
  display: flex; justify-content: flex-end;
  padding-top: 1.6rem; margin-top: 1.6rem;
  border-top: 1px solid #f0e6de;
}

.submit-btn {
  display: inline-flex; align-items: center; gap: 0.7rem;
  padding: 0.85rem 2.4rem;
  background: linear-gradient(135deg, #7c2d12, #c2440a);
  color: #fff; border: none; border-radius: 0.8rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.4rem; font-weight: 700;
  cursor: pointer; box-shadow: 0 4px 16px rgba(124,45,18,0.28);
  transition: all 0.2s;
}
.submit-btn svg { width: 1.7rem; height: 1.7rem; }
.submit-btn:hover { transform: translateY(-2px); box-shadow: 0 8px 24px rgba(124,45,18,0.38); }

/* ── Table ── */
.table-wrap {
  overflow-x: auto; border: 1px solid #e5ddd5;
  border-radius: 0.8rem; margin-bottom: 0;
}
.data-table { width: 100%; border-collapse: collapse; font-size: 1.3rem; }
.data-table thead tr { background: #f0ebe3; }
.data-table th {
  padding: 1.1rem 1.3rem;
  text-align: left; font-size: 1.15rem; font-weight: 600;
  color: #4a3028; text-transform: uppercase; letter-spacing: 0.05em;
  border-bottom: 2px solid #e5ddd5; white-space: nowrap;
}
.data-table td {
  padding: 1rem 1.3rem; color: #1c0f0a;
  border-bottom: 1px solid #f0ebe3; vertical-align: middle;
}
.data-table tbody tr:last-child td { border-bottom: none; }
.data-table tbody tr:hover { background: #fdf9f6; }
.data-table tbody tr:nth-child(even) { background: #faf8f6; }
.data-table tbody tr:nth-child(even):hover { background: #fdf9f6; }

.idx-cell     { color: #9a8070; font-size: 1.2rem; text-align: center; width: 3.5rem; }
.sabha-cell   { }
.sabha-name   { font-weight: 600; color: #1c0f0a; }
.contact-cell { color: #4a3028; }

/* Remove button */
.remove-btn {
  display: inline-flex; align-items: center; gap: 0.5rem;
  padding: 0.5rem 1.1rem;
  background: #fff; border: 1.5px solid #e5ddd5;
  color: #b91c1c; border-radius: 0.6rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.2rem; font-weight: 500;
  cursor: pointer; transition: all 0.2s;
}
.remove-btn svg { width: 1.4rem; height: 1.4rem; }
.remove-btn:hover { background: #b91c1c; color: #fff; border-color: #b91c1c; }

/* Empty state */
.empty-state {
  display: flex; flex-direction: column; align-items: center;
  padding: 3.5rem 2rem; color: #9a8070;
}
.empty-icon {
  width: 5rem; height: 5rem;
  background: #f0ebe3; border-radius: 50%;
  display: flex; align-items: center; justify-content: center;
  margin-bottom: 1rem;
}
.empty-icon svg { width: 2.4rem; height: 2.4rem; stroke: #c2440a; }
.empty-state p { font-size: 1.4rem; color: #9a8070; margin: 0; }

/* ── Add Sabha button ── */
.add-sabha-btn {
  display: inline-flex; align-items: center; gap: 0.6rem;
  padding: 0.7rem 1.8rem;
  background: linear-gradient(135deg, #166534, #16a34a);
  color: #fff; border: none; border-radius: 0.7rem;
  font-family: 'DM Sans', sans-serif; font-size: 1.35rem; font-weight: 600;
  cursor: pointer; box-shadow: 0 4px 12px rgba(22,101,52,0.25);
  transition: all 0.2s; white-space: nowrap;
}
.add-sabha-btn svg { width: 1.5rem; height: 1.5rem; }
.add-sabha-btn:hover { transform: translateY(-1px); box-shadow: 0 6px 18px rgba(22,101,52,0.35); }

/* ── Responsive ── */
@media (max-width: 768px) {
  .profile-page  { padding: 1.5rem 1rem 3rem; }
  .page-title    { font-size: 2rem; }
  .page-header   { flex-direction: column; }
  .form-card     { padding: 1.6rem; }
  .two-col       { grid-template-columns: 1fr; }
  .three-col     { grid-template-columns: 1fr 1fr; }
  .invisible     { display: none; }
  .add-sabha-btn { width: 100%; justify-content: center; margin-top: 0.8rem; }
}
@media (max-width: 520px) {
  .three-col { grid-template-columns: 1fr; }
  .submit-btn { width: 100%; justify-content: center; }
}
</style>